<div
  [class]="hasBaseClass ? 'frogo-dropdown-container fk-pv1' : ''"
  [ngClass]="getDirectionStyles()">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
